import { useSelector }                   from 'react-redux'
import { useNavigate }                   from 'react-router-dom'
import Pagination                        from '../../Pagination/Pagination'
import { SelectOption }                  from '../../Select/Select'
import SettingsShopProductsListTableItem from './SettingsShopProductsListTableItem'

export default function SettingsShopProductsListTable( props: any ): JSX.Element {
  const {
          shopCategories,
          shopProducts,
          pagination,
          categoryId,
          handleCategoryChange
        }                = props
  const navigate: any    = useNavigate()
  const currentUser: any = useSelector( ( state: any ): any => state.currentUser.user )

  const urlFormat: any = ( paramsString: string = '' ): string => {
    let urlString: string = '/settings/shop/products'
    const params: any     = new URLSearchParams( paramsString )

    if ( categoryId ) {
      params.set( 'category', categoryId )
    }

    return params ? `${ urlString }?${ params }` : urlString
  }

  const setCurrentPage: any = ( page: number = 1 ): any => navigate( urlFormat( `page=${ page }` ) )

  return (
    <>
      { shopProducts.data?.length < 1 && <p>No products yet...</p> }

      <div className="py-4 px-4 2xl:px-8 mb-2 lg:mb-4 flex w-full">
        <div className="flex items-center pl-1 text-grey-input rounded-2xl border border-grey-light overflow-hidden w-full md:w-auto">
          <SelectOption
            fieldClasses="border-none focus:ring-0 font-medium w-full md:w-[255px]"
            wrapperClasses="w-full"
            setSelected={ handleCategoryChange }
            selected={ categoryId }
            placeholder="Category (All)"
            options={ shopCategories.map( ( cat: any ): any => {
              return { key: cat.id, value: cat.name }
            } ) }
          />
        </div>
      </div>

      <div className="bg-blue-subtle p-2 2xl:p-4 rounded-3xl overflow-x-auto space-y-2 2xl:space-y-4">
        { shopProducts.map( ( shopProduct: any, index: any ): any =>
                              <SettingsShopProductsListTableItem
                                shopCategory={ shopCategories.find( ( c: any ): boolean => c.id === shopProduct.category_id ) }
                                key={ index }
                                shopProduct={ shopProduct }
                                currentUser={ currentUser }
                              /> ) }
        </div>

      { ( pagination?.totalPages > 0 ) &&
        <Pagination
          className="justify-content-center"
          currentPage={ pagination?.page }
          totalCount={ pagination?.totalResults }
          pageSize={ pagination?.perPage }
          onPageChange={ ( page: any ): any => setCurrentPage( page ) }
        />
      }
    </>
  )
}
